// extracted by mini-css-extract-plugin
export default {"element":"UserImageProfile_element__-sDiZ","name":"UserImageProfile_name__CBbbt"};